import { AnfrageService } from '@/api/service-index';
import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { GlobalEnumerationsAceXfoundportalobjekt } from '@/api/model-index';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GetAllProjektProjektideeAnfragenResolver  {
  constructor(protected anfrageService: AnfrageService)
  {
    //
  }

  /**
   * Get all applications containing projects and projectideas.
   * 
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   * @returns Observable<BewerbungListDisplayModel>
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AnfrageListDisplayModel[]> {
    return this.anfrageService.apiAnfrageGet({"x-anfragescope": [GlobalEnumerationsAceXfoundportalobjekt.Projekt, GlobalEnumerationsAceXfoundportalobjekt.Projektidee] })
      .pipe(
        map(response => {
          return response;
        })
      );    
  }
}
